import Resource from './Resource'

class ProfessionalCategory extends Resource {}

export default ProfessionalCategory
